<button class="btn btn-md btn-block" (click)="onClick()" [disabled]="disabled">
  <mat-icon *ngIf="showBookmark" class="icon mr-2">bookmark</mat-icon>
  <span class="mx-auto">{{text}}</span>
</button>
